"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionType = void 0;
class TransactionType {
    static Shipping = 'Shipping';
    static Receiving = 'Receiving';
    static Adjustments = 'Adjustments';
    static Assemblies = 'Assemblies';
    static Returns = 'Returns';
    // add the validator for TransactionType
    static transactionTypeValid(transactionType) {
        if (!transactionType) {
            return false;
        }
        const validTransactionTypes = Object.values(this);
        return validTransactionTypes.includes(transactionType);
    }
}
exports.TransactionType = TransactionType;
